import { render, staticRenderFns } from "./message-reply.vue?vue&type=template&id=67acdb1a&scoped=true&"
import script from "./message-reply.vue?vue&type=script&lang=js&"
export * from "./message-reply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67acdb1a",
  null
  
)

export default component.exports